import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";
import Feature from "src/js/stores/user/Feature";
import { ConstrainedListFilterMust } from "react-migration/domains/search/typings/SourcingToolFilters/types";

export const TenureFilter: ISourcingToolSearchFilter = {
  id: "tenure-uk",
  type: "checkbox",
  must: ConstrainedListFilterMust.MATCH_ANY,
  field: "sidebar.react.search_sidebar.tenure_type",
  mustOptions: [ConstrainedListFilterMust.MATCH_ANY, ConstrainedListFilterMust.MATCH_NONE],
  isDefault: [Feature.ukLocationSearch],
  updateFilterDialogIsVisible: false,
  searchTypes: [SearchType.SOURCING_TOOL_UK],
  values: [
    {
      key: "freehold",
      name: "Freehold",
      checked: true, //This is the default for now. We'll have to change this when introduce leasehold data
    },
    {
      key: "leasehold",
      name: "Leasehold",
    },
  ],
};
